export default __webpack_public_path__ + "static/media/PrayerEvening.1331bc3b.svg";